'use client'

import { type FormEvent } from 'react'
import { Button } from '@ui/base/button'
import { Field, FieldLabel } from '@ui/base/field'
import { Input } from '@ui/base/input'
import { SearchIcon } from 'lucide-react'

import { type CatalogSearchParams } from '../lib/search-params'
import { useCatalogFilters } from './catalog-filters-context'
import { useCatalogQuery } from './catalog-query'

/** Поиск по названию и географии: стоит над списком, остальные фильтры — слева. */
export const CatalogSearchForm = ({ params }: { params: CatalogSearchParams }) => {
  const { query, setQuery } = useCatalogQuery()
  const { navigate } = useCatalogFilters()

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate(() => ({ page: undefined }))
  }

  return (
    <form
      method="get"
      action="/fulfillment"
      className="grid min-w-0 items-end gap-3 sm:grid-cols-[minmax(0,1fr)_auto]"
      onSubmit={handleSubmit}
    >
      {params.city && <input type="hidden" name="city" value={params.city} />}
      {params.marketplaces.length > 0 && (
        <input type="hidden" name="marketplace" value={params.marketplaces.join(',')} />
      )}
      {params.shipmentTypes.length > 0 && (
        <input type="hidden" name="shipment_type" value={params.shipmentTypes.join(',')} />
      )}
      {params.deliveryFrequency && <input type="hidden" name="delivery_frequency" value={params.deliveryFrequency} />}
      {params.sort !== 'newest' && <input type="hidden" name="sort" value={params.sort} />}
      <Field>
        <FieldLabel htmlFor="fulfillment-catalog-query">Город, регион или название ФФ</FieldLabel>
        <Input
          id="fulfillment-catalog-query"
          name="query"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          maxLength={160}
          placeholder="Например, Москва или Московская область"
        />
      </Field>
      <Button type="submit" variant="secondary">
        <SearchIcon className="size-4" aria-hidden />
        Показать
      </Button>
    </form>
  )
}
